export default __webpack_public_path__ + "static/tingting_negar-37d89a6777ddbd380d2aae70a020ec23.png";